module.exports = __webpack_public_path__ + "static/fleet-description-258b8f1757761969711481a530c024e2.png";